import(/* webpackMode: "eager" */ "/root/repo/src/app/score-check/overall/page.tsx");
